import * as React from "react";
// import { dispatch } from "@rematch/core";
// import { connect } from "react-redux";
import { Table, Input, Button, Icon } from "antd";
import { connect } from "react-redux";
// import { AccountFragment } from "widget/orderListColFragment";

import { Accounts, GroupNumber, RenderDate, RenderSkuName, SaleNumber } from 'widget/orderListColFragment/expElement'

// 生成唯一id的库
import cuid from "cuid";

// import FieldDrawer from "../fieldDrawer";
// import { PositionProperty } from "../../../node_modules/csstype";
// 数据模型
// import Model from "../../viewModel";
// 小工具栏
import SmallTools from "../smallTools";
import Listdetail from "../detailFrom/listdetail";

import './index.css'
interface IProps {
  value?: any;
  field?: any;
  modelName?: any;
  onChange?: any;
  setValue?: any;
  width?: any;
  placeholder?: any;
  share?: any;
}

enum EFilterType {
  input = 0,
  button = 1,
  dateRange = 2,
  select = 3,
  country = 4,
  city = 5,
  area = 6,
  // 国家，城市联动
  countryCity = 7,
  // 订单来源 二级联动
  secondaryLinkage = 8,
  // 贸易状态
  tsSecondarLinkage = 9,
  // 日期f范围控件
  rangePicker = 10
}

// 色彩
enum EColor {
  // 强调色
  accent = "#f50",
  // 事物进行中
  underway = "#108ee9",
  // 正常状态
  nomarl = "#aaa"
}

// interface IColumn {
//   title?: any;
//   dataIndex?: any;
//   key?: any;
//   width?: any;
//   align?: any;
//   filterType?: EFilterType;
//   filterDropdown?: any;
//   onFilterDropdownVisibleChange?: any;
// }

interface ITableEnhanceProps extends IProps {
  timestamp?: any;
  data?: any;
  columns?: any;
  model?: any;
  modelName?: any;
  componentName?: any;
  onSearch?: any;
  rowKey?: any;
  // 改变每页显示条目数
  onShowSizeChange?: any;
  // 跳转到某页
  onChange?: any;
  // 总条数
  total?: any;
  // 默认条数
  defaultPageSize?: any;
  style?: any;
  scroll: any;
  // 把当前组件的实例对象传递给父组件
  onRef?: any;
  // 把选中的id数据传递给父组件
  returnCheckedKey?: any;
  // 表格的样式
  className?: any;
  // 当前页
  pageIndex?: any;
  // 当前选中的行
  selectedRowKeys: any;
  // 列表loading状态
  loading: any;
  // 是否隐藏复选框
  isHideRowSelection?: any;
  // 特殊表格
  expType?: any
}

// table增强组件
class TableEnhance extends React.Component<ITableEnhanceProps, any> {
  filters: any = {};
  tableClassName: string = "";

  constructor(props: ITableEnhanceProps) {
    super(props);
    this.tableClassName = this.props.className || cuid();
    let columns: any = [],
      tColumns: any = [];
    // 给column 添加自定义过滤器
    if (this.props.columns) {
      columns = [...this.props.columns];

      for (let item of columns) {
        let _item = {};
        if (!item) continue;
        switch (item.filterType) {
          case EFilterType.input:
            _item = {
              ...this.initFilter({
                placeholder: `键入${item.title}`,
                elementName: item.key
              }),
              ...item
            };
            break;
          default:
            _item = { ...item };
            break;
        }
        _item = {
          ..._item,
          dataIndex: item.key,
          width: item.width || 100,
          filterDropdownVisible: false
        };
        tColumns.push(_item);
      }
    }

    //const scroll = this.calcScroll(tColumns);
    this.state = {
      ...this.state,
      // 保存最新的，会变化的columns数据
      // columns: tColumns,
      // 保存最原始的columns数据
      originalColumns: tColumns,
      // 字段抽屉框组件数据
      fieldDrawerData: [],
      // 字段抽屉组件返回的需要隐藏的字段
      targetKeys: [],
      record: {},
      visible: false
      //  scroll: scroll
    };

    // 传递当前组件的实例
    this.props.onRef && this.props.onRef(this);
  }

  //componentWillMount() {
  componentDidMount() {
    this.getTransferField();
  }

  // 获取穿梭框需要的字段
  getTransferField = () => {
    const tFieldkData: any = [];
    for (const item of this.state.originalColumns) {
      if (item.key) {
        const data = {
          key: item.key,
          title: item.title,
          description: "",
          chosen: 1
        };
        tFieldkData.push(data);
      }
    }

    this.setState({
      fieldDrawerData: tFieldkData
    });
  };

  // 隐藏过滤面板
  hiddenFilterDropdown = (field, visible) => {
    let _tCollumns: any = this.state.columns;
    for (let tItem of _tCollumns) {
      if (tItem.key === field) {
        tItem.filterDropdownVisible = visible || false;
        // 字段匹配成功后，跳出循环避免无效运算
        break;
      }
    }

    this.setState({
      columns: _tCollumns
    });
  };

  // 更新redux中的数据
  updateAntDemoData = (field, value) => {
    let formInfo = {};
    formInfo[field] = value;

    this.props.setValue({
      formInfo,
      model: this.props.modelName
    });
  };

  // 设置过滤器状态
  setfliterState = field => {
    let state = { ...this.state };
    const element = this.state[field];
    const value = element.input.value;

    if (value && value.trim()) {
      state[`${field}Filtering`] = true;
    } else {
      state[`${field}Filtering`] = false;
    }

    this.setState({ ...state });
  };

  // 初始化过滤器
  initFilter = ({ placeholder, elementName }) => {
    return {
      // 绘制过滤面板
      filterDropdown: (() => {
        const initEle = ele => {
          //          let state = { ...this.state };

          if (ele) {
            //state[elementName] = ele;
            this.filters[elementName] = ele;
          }
          //        this.setState({ ...state });
        };
        const search = () => {
          // 执行查询
          this.props.onSearch && this.props.onSearch();
          // 隐藏过滤面板
          this.hiddenFilterDropdown(elementName, false);
          // 更新过滤器状态
          this.setfliterState(elementName);
        };

        const reset = () => {
          const element = this.state[elementName]; //.input.value = "";
          element.input.value = "";

          // 更新redux数据
          this.updateAntDemoData(elementName, "");

          // 隐藏过滤面板
          this.hiddenFilterDropdown(elementName, false);

          // 更新过滤器状态
          this.setfliterState(elementName);
        };

        // 输入框值更改事件，过滤面板中的输入框信息更改时更新state中的值
        const onChange = e => {
          const field: string = e.target.attributes["data-field"].value;

          // 更新redux数据
          this.updateAntDemoData(field, e.target.value);
        };

        return (
          <div className="custom-filter-dropdown">
            <Input
              onChange={onChange}
              ref={initEle}
              data-field={elementName}
              placeholder={placeholder}
            />
            <Button type="primary" onClick={search}>
              搜索
            </Button>
            <Button onClick={reset}>重置</Button>
          </div>
        );
      })(),
      // 监听过滤面板的显示状态
      onFilterDropdownVisibleChange: visible => {
        if (visible) {
          setTimeout(() => {
            const ele = this.filters[elementName];
            //  document.querySelector(ele).focus();
            ele && ele.focus();
          });
        }
        this.hiddenFilterDropdown(elementName, visible);
      },
      // 过滤图标
      filterIcon: filtered => {
        // 更新过滤器状态
        let style = { color: EColor.nomarl };
        if (
          this.state &&
          this.state.hasOwnProperty(`${elementName}Filtering`)
        ) {
          style.color = this.state[`${elementName}Filtering`]
            ? EColor.underway
            : EColor.nomarl;
        }

        return <Icon type="filter" style={style} />;
      }
    };
  };

  // // 计算滚动条参数 计算横向滚动条的长度
  //  calcScroll = columns => {
  //   const scroll = { x: 0, y: 0 };
  //   for (const item of columns) {
  //     console.log("item.width", item.width);
  //     scroll.x += item.width || 100;
  //   }
  //   scroll.y = 500;
  //   return scroll;
  // };

  // 分页参数
  getPaginationParam = () => {
    // let current = {};
    // if (!this.props.pageIndex || this.props.pageIndex == 1) {
    //   current = { current: 1 };
    // }
    return {
      showSizeChanger: true,
      // showQuickJumper: true,
      // showSizeChanger: true,
      // 当前页
      current: this.props.pageIndex,
      defaultCurrent: 1,
      total: this.props.total,
      // 默认条数
      defaultPageSize: this.props.defaultPageSize || 20,
      pageSizeOptions: ["10", "20", "30", "40", "50", "60"],
      onShowSizeChange: this.onShowSizeChange,
      onChange: this.onChange
    };
  };

  // 改变每页显示条目数
  onShowSizeChange = (current, pageSize) => {
    this.props.onShowSizeChange(current, pageSize);
  };

  // 列表滚动条回到起始位置
  listScrollToStart = () => {
    // 修复切换页码时，滚动条没有回到起始位置
    let tableClassName: string = this.tableClassName;

    if (tableClassName != null) {
      const tableClassNameSelector = document.querySelector(
        "." + tableClassName
      );
      if (tableClassNameSelector) {
        const antTableBody = tableClassNameSelector.querySelector(
          ".ant-table-body"
        );
        if (antTableBody) antTableBody.scrollTop = 0;
      }
    }
  };

  // 跳转到某页
  onChange = pageNumber => {
    this.props.onChange(pageNumber);
  };

  showDetail = (record, index) => {
    return {
      onDoubleClick: event => {
        this.setState({
          record: record,
          visible: true
        })
        console.log(record)
      },
    }
  }

  reset = () => {
    this.setState({
      record: {},
      visible: false
    })
  }

  colRowSpan() {
    let columns;
    columns = this.props.columns.map(item => {
      switch (item.key) {
        case "account":
          item.render = (text, record) => {
            const obj = {
              children: <Accounts text={text} record={record}></Accounts>,
              props: {
                rowSpan: null,
              },
            }
            obj.props.rowSpan = record.rowSpan;
            return obj
          }
          break
        case "groupNumber":
          item.render = (text, record) => {
            const obj = {
              children: <GroupNumber text={text} record={record}></GroupNumber>,
              props: {
                colSpan: null,
              },
            }
            obj.props.colSpan = record.colSpan;
            return obj
          }
          break
        case "submitDate":
          item.render = (text, record) => {
            const obj = {
              children: <RenderDate text={text} record={record}></RenderDate>,
              props: {
                colSpan: null,
              },
            }
            obj.props.colSpan = record.colSpan;
            return obj
          }
          break
        case "goTime":
          item.render = (text, record) => {
            const obj = {
              children: <RenderDate text={text} record={record}></RenderDate>,
              props: {
                colSpan: null,
              },
            }
            obj.props.colSpan = record.colSpan;
            return obj
          }
          break
        case "skuName":
          item.render = (text, record) => {
            //  REACT_APP_ORDER_DETAIL_URL="https://admin.cattrip.net/order/itemdetails/id/"
            const obj = {
              children: <RenderSkuName text={text} record={record}></RenderSkuName>,
              props: {
                colSpan: null,
              },
            }
            obj.props.colSpan = record.colSpan;
            return obj
          }
          break
        case "saleNum":
          item.render = (text, record) => {
            const obj = {
              children: <SaleNumber text={text} record={record}></SaleNumber>,
              props: {
                colSpan: null,
              },
            }
            obj.props.colSpan = record.colSpan;
            return obj
          }
          break
        case "headid":
          item.render = (text, record) => {
            const obj = {
              children: text || '-',
              props: {
                colSpan: null,
              },
            }
            obj.props.colSpan = record.colSpan;
            return obj
          }
          break
      }
      return item
    })
    return columns
  }


  // rowSelection object indicates the need for row selection 复选框

  initTable = () => {
    let columns;
    // 日期重叠检查合并表格
    if (this.props.expType) {
      columns = this.colRowSpan()
    } else {
      columns = this.props.columns
    }

    // 不显示复选框
    let rowSelection;
    if (!this.props.isHideRowSelection) {
      rowSelection = {
        columnWidth: 20,
        selectedRowKeys: this.props.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          // 把选中的id值传递到父组件
          if (this.props.returnCheckedKey) {
            this.props.returnCheckedKey(selectedRowKeys);
          }
        },
        getCheckboxProps: record => ({
          width: 20
        })
      };
    }

    // 设置table loading状态
    const setSpin = () => {
      if (this.props.loading) {
        return {
          spinning: true,
          tip: "加载中..."
        };
      } else {
        return false;
      }
    };
    let expandedRowKeys: any = []
    this.props.data.map(item => {
      expandedRowKeys.push(item.id)
    })
    return (
      <div>
        <Listdetail Data={this.state.record} Visible={this.state.visible} Reset={this.reset} />
        <Table
          className={this.tableClassName}
          rowSelection={rowSelection}
          style={{ ...this.props.style }}
          scroll={this.props.scroll}
          loading={setSpin()}
          onRow={this.showDetail}
          // 表格主键
          rowKey={this.props.rowKey || "id"}
          expandedRowKeys={expandedRowKeys}
          // size="middle"
          bordered={true}
          columns={columns}
          dataSource={this.props.data}
          pagination={this.getPaginationParam()}
        />
      </div>
    );
  };

  shouldComponentUpdate(nextProps: any, nextState: any, nextContext: any) {
    if (this.props.timestamp != nextProps.timestamp) {

      this.listScrollToStart();
      return true;
    }

    if (this.props.loading != nextProps.loading) {
      return true;
    }

    // 比较scroll值是否变化
    if (
      this.props.scroll &&
      (this.props.scroll.x != nextProps.scroll.x ||
        this.props.scroll.y != nextProps.scroll.y)
    ) {
      console.log("scroll变化了");
      return true;
    }

    return true;
  }



  render() {
    return (
      <SmallTools
        content={this.initTable()}
        isOpenEnlarge={false}
        isOpenFieldDrawer={false}
      />
    );
  }
}

const mapDispatch = dispatch => {
  return {
    getOrderList: dispatch.orderInfo.getOrderList,
    setValue: dispatch.antDemo.setValue
  };
};

export default connect(
  null,
  mapDispatch
)(TableEnhance);
